import prepareOrganizationStructuredPageData from "@insite/client-framework/Common/Utilities/prepareOrganizationStructuredPageData";
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import { Website } from "@insite/client-framework/Services/WebsiteService";


const prepareOrganizationStructuredPageDataWithId = (website: Website) => {
    const url: { protocol: string; host: string } = IS_SERVER_SIDE ? getUrl()! : window.location;
    const authority = `${url.protocol}//${url.host}`;

    const { "@context": context, "@type": type, ...rest } = JSON.parse(prepareOrganizationStructuredPageData(website));

    const data = {
        "@context": context,
        "@type": type,
        "@id": `${authority}/#organization`,
        ...rest,
    };

    return JSON.stringify(data);
};

export default prepareOrganizationStructuredPageDataWithId;